import * as _ from "lodash";
import { reactive, h } from 'vue'
import dayjs from "dayjs";
import * as  config from "@/config";
import axios from "axios";
import { basePicUrl } from "@/config";
import Decimal from "decimal.js";
export const DARA_FORMAT = 'YYYY-MM-DD HH:mm:ss'
import CryptoJS from 'crypto-js'
import { Modal } from "ant-design-vue";
import { api as viewerApi } from "v-viewer";

export const get_local_org_id = () => {
    const org_id = localStorage.getItem('org_id') || '0'

    return org_id
}

export const formatMenuList = (routes, hasGrant) => {
    const result = []
    for (const route of routes) {
        if (hasGrant.includes(route.grantKey) || route.grantKey == '') {
            if (route?.meta?.renderMenu == false) {
                continue
            }
            result.push({
                title: route.name,
                path: route.path,
                meta: route.meta,
                children: route.children ? formatMenuList(route.children, hasGrant) : []
            })
        }
    }
    return result

}


export const getMAP = () => {
    const mapInfoStr = localStorage.getItem('map')
    const mapInfo = JSON.parse(mapInfoStr)
    return mapInfo
}


export const splitSpuText = (supText) => {
    const spuInfo: any = {}
    const spuArr = supText.split('\n')
    if (spuArr.length == 0) return {}
    for (const spuItem of spuArr) {
        const itemArr = spuItem.split(':')
        if (itemArr.length !== 2) return {}
        spuInfo[itemArr[0]] = itemArr[1]
    }

    return spuInfo
}
export const replaceAll = (str, search, replacement) => {
    return str.replace(new RegExp(search, "g"), replacement);
};


export const replaceUrl = (str, urlToReplace, replacement) => {
    // 转义特殊字符
    let escapedUrl = urlToReplace.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    let pattern = new RegExp(escapedUrl, "g");
    return str.replace(pattern, replacement);
}


export const base64ToFile = (base64String, fileName) => {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}


export const checkGrant = (grantKey) => {
    const hasGrant = window.localStorage.getItem('hasGrant') || []
    if (grantKey && hasGrant.includes(grantKey)) return true
    return false

}
/**
 * 小数加法
 */
export const decimal_add = (a, b) => {
    const decimalA = new Decimal(a);
    const decimalB = new Decimal(b);
    return Number(decimalA.plus(decimalB).toString())
}

/**
 * 小数减法
 */
export const decimal_sub = (a, b) => {
    const decimalA = new Decimal(a);
    const decimalB = new Decimal(b);
    return Number(decimalA.minus(decimalB).toString())
}

/**
 * 小数乘法
 */
export const decimal_multi = (a, b) => {
    const decimalA = new Decimal(a);
    const decimalB = new Decimal(b);
    return Number(decimalA.times(decimalB).toString())
}

/**
 * 小数除法
 */
export const decimal_divide = (a, b, precision = 2) => {
    const decimalA = new Decimal(a);
    const decimalB = new Decimal(b);
    return Number(decimalA.dividedBy(decimalB).toFixed(precision))
}


export const get = (obj: any, path: string | string[], defaultValue?: any) => {
    let keys
    if (isArray(path)) {
        keys = path
    }
    else {
        keys = path.split('.');
    }


    let result = obj;

    for (const key of keys) {
        if (result && typeof result === 'object' && key in result) {
            result = result[key];
        } else {
            return defaultValue;
        }
    }

    return result;
};


export const isEmpty = (value: any): boolean => {
    if (value == null) return true; // null 或 undefined
    if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
    if (value instanceof Map || value instanceof Set) return value.size === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
};



export const cloneDeep = <T>(value: T, weakMap = new WeakMap()): T => {
    if (value === null || typeof value !== 'object') return value;

    if (weakMap.has(value)) return weakMap.get(value); // 解决循环引用

    let result: any;

    if (Array.isArray(value)) {
        result = [];
        weakMap.set(value, result);
        for (const item of value) {
            result.push(cloneDeep(item, weakMap));
        }
        return result;
    }

    result = {};
    weakMap.set(value, result);
    for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
            result[key] = cloneDeep(value[key], weakMap);
        }
    }

    return result;
};


export const isArray = (value: any) => {
    return Array.isArray(value);
};


export const set = (obj: object, path: string | string[], value: any) => {
    if (typeof path === 'string') {
        path = path.replace(/\[(\d+)\]/g, '.$1') // 支持数组语法如 a[0].b
            .split('.')
            .filter(Boolean)
    }

    let current: any = obj
    for (let i = 0; i < path.length; i++) {
        const key = path[i]

        // 如果是最后一项，设置值
        if (i === path.length - 1) {
            current[key] = value
        } else {
            // 如果下一层是数字，创建数组，否则对象
            const nextKey = path[i + 1]
            if (current[key] === undefined) {
                current[key] = /^\d+$/.test(nextKey) ? [] : {}
            }
            current = current[key]
        }
    }
    return obj
}


export const formatTime = (input: any) => {
    const date = new Date(input)
    const pad = (n: any) => n.toString().padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}



/**
 * md5
 */
export const md5 = (content) => {
    return CryptoJS.MD5(content).toString()

}



/**
 * 通用提示
 */
export const confirmModal = (title, content, okText = '确认', cancelText = '取消') => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title,
            content,
            okText,
            cancelText,
            centered: true,
            onOk: () => {
                resolve(true)
            },
            onCancel: () => {
                resolve(false)
            }
        })
    })
}



/**
 * 获取系统枚举值
 */
export const getMap = (path: string[]) => {
    const map_str = localStorage.getItem('map')
    const map = JSON.parse(map_str)
    const MAPS = _.get(map, path) || {}
    return MAPS
}

/**
 * 转换下拉菜单形式
 */
export const getMapSelect = (path: string[]) => {

    const MAP = getMap(path)

    const options = Object.entries(MAP).map(([key, value]) => ({ label: value, value: key }))

    return options
}

export const getRandomNumber = (min_num, max_num) => {
    return parseInt(Math.random() * (max_num - min_num + 1) + min_num, 10);
};


/**
 * 复制到剪贴板
 */
export const copyTetx = async (text) => {
    try {
        // 方法1: 优先使用现代剪贴板API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }

        // 方法2: 使用document.execCommand作为备选
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // 避免滚动到底部
        document.body.appendChild(textarea);
        textarea.select();

        // 兼容iOS
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            const range = document.createRange();
            range.selectNodeContents(textarea);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textarea.setSelectionRange(0, 999999);
        }

        const success = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (!success) throw new Error('复制失败');
        return true;
    } catch (err) {
        console.error('复制失败:', err);

        // 方法3: 提示用户手动复制（作为最后的手段）
        try {
            window.prompt('请手动复制以下文本:', text);
            return false; // 不能确定用户是否真的复制了
        } catch (e) {
            return false;
        }
    }
}


/**
 * 预览图片
 */
export const previewImages = (images: string[]) => {
    viewerApi({
        images: images,
    });
}


export const sleep = (second: number) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true)
        }, second * 1000)
    })
}



/**
 * 选择上传的文件
 */
export const chooseUploadFile = <T extends boolean>(
    accept,
    multiple: T
  ): Promise<T extends true ? File[] : File> => {
    return new Promise((resolve, reject) => {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = accept
      input.multiple = multiple
      input.style.display = 'none'
  
      input.addEventListener('change', () => {
        const files = input.files;
        resolve(multiple ? Array.from(files) : files[0] as any);
      })
  
      document.body.appendChild(input)
      input.click()
    })
  }
  